export default "__VITE_ASSET__qof4gDm2__"